import {Controller} from "@hotwired/stimulus"

class PayoutConfigController extends Controller {
    static targets = [
        "entryFee", "stageCount",
        "potAmounts", "stageAmount", "generalAmount",
        "stageTiers", "generalTiers", "validationMessages", "validationList"
    ]

    connect() {
    }

    updatePotSplit(evt) {
        console.log("updating pot split, triggered by: ", evt?.target);
        const entryFeeInput = this.hasEntryFeeTarget ? this.entryFeeTarget : null;
        const stageCountInput = this.hasStageCountTarget ? this.stageCountTarget : null;
        const stageAmountInput = this.hasStageAmountTarget ? this.stageAmountTarget : null;
        const generalAmountInput = this.hasGeneralAmountTarget ? this.generalAmountTarget : null;

        if (!entryFeeInput || !generalAmountInput) return

        const entryFee = parseInt(entryFeeInput.value) || 0
        const stageCount = stageCountInput ? (parseInt(stageCountInput.value) || 0) : 0;
        const stageAmount = stageAmountInput ? (parseFloat(stageAmountInput.value) || 0) : 0
        const generalAmount = parseFloat(generalAmountInput.value) || 0

        // Auto-adjust the other percentage
        const changedInput = evt?.target
        if (stageAmountInput && changedInput === stageAmountInput) {
            const totalStageAmountValue = stageAmount * stageCount
            generalAmountInput.value = (entryFee - totalStageAmountValue).toFixed(2)
        } else {
            const perStageAmountValue = stageCount > 0 ? (entryFee - generalAmount) / stageCount : 0
            if (stageAmountInput) {
                stageAmountInput.value = perStageAmountValue.toFixed(2)
            }
            if (changedInput !== generalAmountInput) {
                const totalStageAmountValue = stageAmount * stageCount
                generalAmountInput.value = (entryFee - totalStageAmountValue).toFixed(2)
            }
        }
    }

    removeTier(event) {
        const tierRow = event.target.closest('.prize-tier')
        if (tierRow) {
            tierRow.remove()
            this.validatePercentages()
        }
    }

    validatePercentages() {
        const errors = []

        // Validate stage tiers
        if (this.hasStageTiersTarget) {
            const stageTiers = this.stageTiersTarget.querySelectorAll('.prize-tier')
            const stagePercentages = Array.from(stageTiers).map(tier => {
                const input = tier.querySelector('[data-testid$="-tier-percentage"]')
                return parseFloat(input?.value) || 0
            })
            const stageTotal = stagePercentages.reduce((sum, pct) => sum + pct, 0)

            if (stageTiers.length > 0 && Math.abs(stageTotal - 100) > 0.01) {
                errors.push(`Stage prize tier percentages must sum to 100% (currently ${stageTotal.toFixed(2)}%)`)
            }
        }

        // Validate general tiers
        if (this.hasGeneralTiersTarget) {
            const generalTiers = this.generalTiersTarget.querySelectorAll('.prize-tier')
            const generalPercentages = Array.from(generalTiers).map(tier => {
                const input = tier.querySelector('[data-testid$="-tier-percentage"]')
                return parseFloat(input?.value) || 0
            })
            const generalTotal = generalPercentages.reduce((sum, pct) => sum + pct, 0)

            if (generalTiers.length > 0 && Math.abs(generalTotal - 100) > 0.01) {
                errors.push(`General prize tier percentages must sum to 100% (currently ${generalTotal.toFixed(2)}%)`)
            }
        }

        // Validate pot split
        const stagePotInput = document.querySelector('[data-testid="stage-pot-percentage"]')
        const generalPotInput = document.querySelector('[data-testid="general-pot-percentage"]')

        if (stagePotInput && generalPotInput) {
            const stagePot = parseFloat(stagePotInput.value) || 0
            const generalPot = parseFloat(generalPotInput.value) || 0
            const potTotal = stagePot + generalPot

            if (Math.abs(potTotal - 100) > 0.01) {
                errors.push(`Stage and General pot percentages must sum to 100% (currently ${potTotal.toFixed(2)}%)`)
            }
        }

        this.displayValidationErrors(errors)
    }

    displayValidationErrors(errors) {
        const messagesContainer = this.validationMessagesTarget
        const errorsList = this.validationListTarget

        if (errors.length > 0) {
            errorsList.innerHTML = errors.map(error => `<li>${error}</li>`).join('')
            messagesContainer.style.display = 'block'
        } else {
            messagesContainer.style.display = 'none'
        }
    }
}

export default PayoutConfigController